import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import VipImage from "../../assets/vipimage.png";
import Button from "../button/Button";
import Frame from "../../assets/Frame 155978.png";
import "./vipUpgrade.css";

const VipUpgrade = () => {
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });
  }, []);
  return (
    <div className="vipUpgradeContainer" data-aos="fade-up">
      <div className="vipUpgradeSubContainer">
        <div className="VipUpgradeImages">
          <img src={Frame} alt="" className="vipUpgradeFrame" />
          <img src={VipImage} alt="" className="vipUpgradeImage" />
        </div>
        <div className="vipUpgradeTextContainer">
          <h4 className="VipUpgradeText">Quickly Upgrade to VIP</h4>
          <article className="VipUpgradeArticle">
            Choose your trading activity, trading volume, or total transaction
            amount from other platforms over the past 30 days to quickly gain
            access to the high-level VIP membership experience at Giftcard8. You
            can enjoy the benefits of being a Giftcard8 member!
          </article>
          <Button className="vipUpgradeButton" actionType="redirect" redirectUrl="https://dashboard.giftcard8.com/account">Upgrade to VIP Now</Button>
        </div>
      </div>
    </div>
  );
};

export default VipUpgrade;
